import { newStepValue } from '../../../../services/flowBuilder/utils/constants';
import { DynamicLayout } from '../../formbuilder';

const allForOne = ['latitude', 'longitude', 'name', 'radiusMeters'];

export const timePicker: DynamicLayout = {
  json: {
    menu: {
      menuType: 'timePicker',
      menuHeader: '',
      menuParams: {
        description: '',
        icon: '',
        timeslots: '',
        variableName: '',
        location: {
          latitude: '',
          longitude: '',
          name: '',
          address: '',
          radiusMeters: '',
        },
      },
    },
    type: 'menu',
    next: newStepValue,
    metadata: {},
  },
  paths: [
    'menu.menuParams.icon',
    'menu.menuHeader',
    'menu.menuParams.description',
    'menu.menuParams.timeslots',
    'menu.menuParams.variableName',
    'menu.menuParams.location.latitude',
    'menu.menuParams.location.longitude',
    'menu.menuParams.location.name',
    'menu.menuParams.location.address',
    'menu.menuParams.location.radiusMeters',
    'next',
  ],
  groups: [
    {
      Parameters: [
        'menu.menuParams.icon',
        'menu.menuHeader',
        'menu.menuParams.description',
        'menu.menuParams.timeslots',
        'menu.menuParams.variableName',
        'menu.menuParams.location.latitude',
        'menu.menuParams.location.longitude',
        'menu.menuParams.location.name',
        'menu.menuParams.location.address',
        'menu.menuParams.location.radiusMeters',
      ],
    },
    {
      Logic: ['next'],
    },
  ],
  layout: {
    menuHeader: {
      type: 'text',
      label: 'Title',
      validators: {
        required: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    icon: {
      type: 'image',
      label: '',
      validators: {
        required: false,
      },
    },
    timeslots: {
      type: 'text',
      label: 'Timeslots',
      validators: {
        required: true,
      },
    },
    variableName: {
      type: 'text',
      label: 'Variable Name',
      validators: {
        required: true,
      },
    },
    latitude: {
      type: 'text',
      label: 'Latitude',
      validators: {
        allForOne: allForOne,
      },
    },
    longitude: {
      type: 'text',
      label: 'Longitude',
      validators: {
        allForOne: allForOne,
      },
    },
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        allForOne: allForOne,
      },
    },
    address: {
      type: 'text',
      label: 'Address',
    },
    radiusMeters: {
      type: 'text',
      label: 'Radius',
      validators: {
        allForOne: allForOne,
      },
    },
    next: {
      type: 'next',
      label: 'Point to',
      validators: {
        optionSelected: true,
      },
    },
  },
};
